type EnvSource = Record<string, string | undefined>;

function readFrom(source: EnvSource | undefined, key: string): string | undefined {
  if (!source) return undefined;
  if (!Object.prototype.hasOwnProperty.call(source, key)) return undefined;
  return source[key];
}

export function readEnvVar(key: string): string | undefined {
  try {
    const rt = (globalThis as unknown as { __ENV__?: EnvSource }).__ENV__;
    const im = (globalThis as unknown as { importMetaEnv?: EnvSource }).importMetaEnv;
    const node = (
      globalThis as unknown as { process?: { env?: EnvSource } }
    ).process?.env;
    return (
      readFrom(rt, key) ??
      readFrom(im, key) ??
      readFrom(node, key)
    );
  } catch {
    return undefined;
  }
}
